<script>
  import AboutHero from "../components/About/AboutHero/AboutHero.svelte";
  import AncaWay from "../components/About/AncaWay/AncaWay.svelte";
  import Ourservices from "../components/About/OurServices/Ourservices.svelte";
  import OurTeam from "../components/About/OurTeam/OurTeam.svelte";
  import WhoOurClientsAre from "../components/About/OurClients/WhoOurClientsAre.svelte";
</script>

<main>
  <AboutHero />
  <AncaWay />
  <WhoOurClientsAre />
  <Ourservices />
  <OurTeam />
</main>